<template>
	<vxe-modal v-model="showDrawer"  width="80%" height="800px"    remember :esc-closable="false"
			:destroy-on-close="true" :title="theRow.monitorName">
			<div id="detailChart"></div>
	</vxe-modal>
</template>

<script>
	import * as echarts from 'echarts';
	export default {
		data(){
			return {
				showDrawer:false,
				loading:false,
				detailChart:null,
				theRow:{},
			}
		},
		methods: {
			showView(row,theDate,beginHour,endHour){
				this.theRow = row;
				this.showDrawer = true;
				this.queryDetailData(theDate,beginHour,endHour);
			},
			queryDetailData(theDate,beginHour,endHour){
				this.loading = true;
				let param = {
					meterId:this.theRow.meterId,
					theDate:theDate,
					beginHour:beginHour,
					endHour:endHour,
				};
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MIN_FLOW_DETAIL_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result.reverse();
						this.initCharts();
						this.drawCharts();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			initCharts(){
				let a = window.document.getElementById("detailChart");
				this.detailChart = echarts.init(a);
			},
			drawCharts(){
				var xData = [];
				var flowData = [];
				for(var i = 0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					xData.push(item.readTime);
					flowData.push(item.intervalFlow);
				}
				var option = {
					title:{
						text:'夜间流量趋势图(最小流量:'+this.theRow.minFlowData+')',
						left:'center'
					},
					legend: {
						data: ['抄表时段','流量'],
						x:'center', 
						y:'bottom',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						},
					},
					xAxis: {
						type: 'category',
						data:xData,
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							name:'流量',
							data: flowData,
							type: 'line',
							smooth:true,
						}
				  ]
				};
				this.detailChart.setOption(option);
			},
		},
	}
</script>

<style>
	#detailChart{
		width: 100%;
		height: 580px;
	}
</style>
